<template>
    <div class="living-options-packages">
      <div class="row">
        <div class="col-12">
          <div class="packages">
            <h5>Property Packages</h5>
            <button class="btn btn-primary mb-4" @click="addPackage()">Add Package</button>
            <div class="mb-2">
              <input class="form-control" type="text" v-model="packageFilterText" placeholder="Filter packages">
            </div>
            <v-table
              :columns="[
                { label: 'Label', field: 'label' },
                { label: 'Lot', field: 'property.label' },
                { label: 'House', field: 'dwelling.label' },
                { label: 'Price', field: 'price' },
              ]"
              :rows="filteredPackages"
              :show-active-toggle="activeUser.access.indexOf('live-toggle') !== -1"
              save-action="SAVE_PACKAGE"
              @edit="activePackageId = $event._id"
              @clone="clonePackage($event)"
              @delete="deletePackage($event._id)"
            />
          </div>
        </div>
      </div>
      <modal-popup :isVisible="!!activePackage" @closeModal="closeModal">
        <div v-if="activePackage" class="modal-row-padding">
          <div class="col-12 mb-4">
            <div class="row">
              <div class="col-12">
                <h3>Editing {{ activePackage.label }}</h3>
              </div>
            </div>
          </div>

          <div class="col-12 mb-4">
            <div class="row">
              <div class="col-6">
                Label
                <input
                  type="text"
                  class="form-control form-control-lg"
                  v-model="activePackage.label"
                  placeholder="i.e. Package Name"
                />
              </div>
              <div class="col-6">
                Wedfeed Label Override 
                <info-box>
                  If left blank the webfeed label will be constructed by combining the dwelling name and lot number.<br>
                  (e.g. The Dwelling - Lot 332)<br>
                  Entering a name in this field will override this.
                </info-box>
                <input
                  type="text"
                  class="form-control form-control-lg"
                  v-model="activePackage.webfeedLabelOverride"
                  placeholder=""
                />
              </div>
              <div class="col-6">
                Price
                <input
                  type="text"
                  class="form-control form-control-lg"
                  v-model="activePackage.price"
                  placeholder=""
                />
              </div>
              <div class="col-6">
                Virtual Tour URL <span class="domain-error" v-if="!isAllowedDomain">domain not allowed</span>
                <input
                  type="text"
                  class="form-control form-control-lg"
                  v-model="activePackage.virtualTourUrl"
                  placeholder=""
                />
              </div>
            </div>
          </div>
          <div class="col-12 mb-4">
            <div class="row">
              <div class="col-6">
                Associated Property
                <input-single-select
                  v-model="activePackage.propertyId"
                  :options="propertyOptions"
                />
              </div>
              <div class="col-6">
                Associated Dwelling
                <input-single-select
                  v-model="activePackage.dwellingId"
                  :options="dwellingOptions"
                />
              </div>
            </div>
          </div>

          <div class="col-12">
            <button class="btn btn-sm btn-outline-danger" @click="closeModal">Cancel</button>
            <button class="btn btn-sm btn-primary ml-1" @click="savePackage(activePackage)">Save</button>
          </div>
        </div>             
      </modal-popup>
    </div>     
</template>
<script>
import _ from 'lodash'
import InfoBox from '@/components/InfoBox'
import InputAsset from '@/components/InputAsset'
import InputSingleSelect from '@/components/InputSingleSelect'
import ModalPopup from '@/components/ModalPopup'
import VTable from '@/components/VTable'

export default {
  components: { InfoBox, InputAsset, InputSingleSelect, ModalPopup, VTable },
  data () {
    return {
      activePackageId: null,
      packageFilterText: '',

      allowedDomains: [
        'matterport.com',
        'my.matterport.com'
      ]
    }
  },

  computed: {
    isAllowedDomain () {
      return true
    },

    activePackage () {
      return _.find(this.packages, _package => {
        return _package._id === this.activePackageId
      })
    },

    activeUser () {
      return this.$store.getters.user
    },

    dwellings () {
      return this.$store.getters.dwellings
    },

    filteredPackages () {
      return _.filter(this.packages, _package => {
        return _package.label.toLowerCase().includes(this.packageFilterText.toLowerCase())
      })
    },

    packages: {
      get () {
        return this.$store.getters.packages
      },
      set (packages) {
        this.$store.commit('SET_PACKAGES', packages)
      }
    },

    properties () {
      return this.$store.getters.properties
    },

    propertyOptions () {
      let propertyOptions = []
      this.properties.forEach(property => {
        propertyOptions.push({
          label: property.label,
          value: property._id
        })
      })
      return propertyOptions
    },

    dwellingOptions () {
      let dwellingOptions = []
      this.dwellings.forEach(dwelling => {
        dwellingOptions.push({
          label: dwelling.label,
          value: dwelling._id
        })
      })
      return dwellingOptions
    },
  },

  methods: {
    async addPackage () {
      const { _id } = await this.$store.dispatch('ADD_NEW_PACKAGE')
      this.activePackageId = _id      
    },

    async clonePackage (_package) {
      const { _id } = await this.$store.dispatch('CLONE_PACKAGE', _package)
      this.activePackageId = _id      
    },

    closeModal () {
      this.activePackageId = null
      this.$store.dispatch('FETCH_PACKAGES')
    },

    deletePackage (id) {
      if (confirm('Are you sure?')) {
        this.$store.dispatch('DELETE_PACKAGE', id)
      }
    },

    savePackage (_package) {
      let modifiedPackage = _package
      if (!this.isAllowedDomain) {
        modifiedPackage.virtualTourUrl = ''
      }

      if (!_package.propertyId || !_package.dwellingId) {
        alert('Property and Dwelling required')
      } else {
        this.$store.dispatch('SAVE_PACKAGE', modifiedPackage)
        this.activePackageId = null
      }
    },
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_PACKAGES')
    this.$store.dispatch('FETCH_PROPERTIES')
    this.$store.dispatch('FETCH_DWELLINGS')
  }
}
</script>

<style lang="scss" scoped>
.domain-error {
  color: rgb(204, 16, 16);
  font-size: .9em;
}
</style>